<template>
    <label :class='getLabelClass()' :for='id'>{{ label }}</label>
    <div class='p-inputgroup'>
        <InputNumber
            :id='id'
            :class='getInputClass()'
            :currency='currency'
            :disabled='desabilita'
            :locale='locale'
            :maxFractionDigits='maxFractionDigits'
            :minFractionDigits='minFractionDigits'
            :mode='mode'
            :modelValue='modelValue'
            v-bind='$attrs'
            @update:modelValue='updateValue'
        />
    </div>
    <small v-if='temErro' class='p-error'>{{ this.mensagemErro || '&nbsp;' }}</small>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        required: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: false,
        },
        desabilita: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: [String, Number],
            default: '',
        },
        mensagemErro: {
            type: String,
            default: '',
        },
        temErro: {
            type: Boolean,
            default: false,
        },
        inputRef: {
            type: Function,
            default: () => {
            },
        },
        minFractionDigits: {
            type: Number,
            default: 0,
        },
        maxFractionDigits: {
            type: Number,
            default: 2,
        },
        mode: {
            type: String,
            default: 'currency',
        },
        currency: {
            type: String,
            default: 'BRL',
        },
        locale: {
            type: String,
            default: 'pt-BR',
        },
    },
    methods: {
        updateValue(event) {
            this.$emit('update:modelValue', event.target.value);
        },
        getInputClass() {
            return {
                'p-invalid': this.temErro,
            };
        },
        getLabelClass() {
            return {
                'error-field-label': this.temErro,
                'required': this.required,
            };
        },
    },
    watch: {
        modelValue() {
            this.$emit('touched', true);
        },
    },
};
</script>
